import NotificationLogsList from "./_components/NotificationLogsList";

const NotificationLogsPage = () => {
  return <NotificationLogsList />;
};

export default NotificationLogsPage;